// Generated by BUCKLESCRIPT VERSION 1.9.3, PLEASE EDIT WITH CARE
'use strict';

var React       = require("react");
var ReasonReact = require("reason-react/lib/js/src/reasonReact.js");
var Logo        = require("./img/logos/reason-react-red.svg");

((require('./createReactApp.css')));

var component = ReasonReact.statelessComponent("App");

function make(message, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: "App"
                }, React.createElement("div", {
                      className: "App-header"
                    }, React.createElement("img", {
                          className: "App-logo",
                          alt: "logo",
                          src: Logo
                        }), React.createElement("h2", undefined, message)), React.createElement("p", {
                      className: "App-intro"
                    }, "To get started, edit", React.createElement("code", undefined, " src/App.re "), "and save to reload."));
    });
  return newrecord;
}

exports.component = component;
exports.make      = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/createReactApp.re
// module id = 21
// module chunks = 0